import {
  handleAddLocationsBySwitch,
  handleLocationSelectBySwitch,
  handleMachineSelectBySwitch,
  handleSpecificLocationSelectBySwitch,
} from '../../../components/store/slices/masterControlBySwitchSelectSlice';
import {
  handleAddLocationsByLocation,
  handleLocationSelectByLocation,
  handleMachineSelectByLocation,
  handleSpecificLocationSelectByLocation,
} from '../../../components/store/slices/masterControlSelectByLocationSlice';

export const selectLocationDispatchHandler = (
  dispatch,
  scope,
  name,
  locationList,
  specificLocationList,
  machineList,
  newSelectedLocations
) => {
  if (scope === 'switch') {
    dispatch(
      handleLocationSelectBySwitch({
        controller: name,
        arr: locationList,
      })
    );
    if (specificLocationList.length > 0) {
      dispatch(
        handleSpecificLocationSelectBySwitch({
          controller: name,
          arr: specificLocationList,
        })
      );
    }
    dispatch(
      handleMachineSelectBySwitch({
        controller: name,
        arr: machineList,
      })
    );

    dispatch(
      handleAddLocationsBySwitch({
        controller: name,
        arr: newSelectedLocations,
      })
    );
  } else {
    dispatch(
      handleLocationSelectByLocation({
        controller: name,
        arr: locationList,
      })
    );
    if (specificLocationList.length > 0) {
      dispatch(
        handleSpecificLocationSelectByLocation({
          controller: name,
          arr: specificLocationList,
        })
      );
    }
    dispatch(
      handleMachineSelectByLocation({
        controller: name,
        arr: machineList,
      })
    );
    dispatch(
      handleAddLocationsByLocation({
        controller: name,
        arr: newSelectedLocations,
      })
    );
  }
};
